export enum LearningProgressStatus {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
}

export enum CardStatus {
  COMPLETED = 'completed',
  DEFAULT = 'default',
}

export const SIDEBAR_WIDTH = 420;
